import { render, staticRenderFns } from "./ViewOrderUserDetailList.vue?vue&type=template&id=493d0155&scoped=true&"
import script from "./ViewOrderUserDetailList.vue?vue&type=script&lang=js&"
export * from "./ViewOrderUserDetailList.vue?vue&type=script&lang=js&"
import style0 from "./ViewOrderUserDetailList.vue?vue&type=style&index=0&id=493d0155&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493d0155",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('493d0155')) {
      api.createRecord('493d0155', component.options)
    } else {
      api.reload('493d0155', component.options)
    }
    module.hot.accept("./ViewOrderUserDetailList.vue?vue&type=template&id=493d0155&scoped=true&", function () {
      api.rerender('493d0155', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/orderMgt/ViewOrderUserDetailList.vue"
export default component.exports